import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type {
  Site,
  SiteApiResponse,
  SiteStatsApiResponse,
  SitesApiResponse,
} from '@/types/site';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

export const useSitesQuery = () => {
  return useSuspenseQuery({
    queryKey: [QUERY_KEYS.sites.getList],
    queryFn: async (): Promise<Site[]> => {
      const response = await XHRAuthorizedClient.get<SitesApiResponse>(
        ENDPOINTS.sites.list
      );
      return response.data.data;
    },
  });
};

export const useSiteQuery = (siteId: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.sites.getDetail, siteId],
    queryFn: async (): Promise<Site> => {
      const response = await XHRAuthorizedClient.get<SiteApiResponse>(
        ENDPOINTS.sites.detail(siteId)
      );
      return response.data.data;
    },
    enabled: !!siteId,
  });
};

export const useSiteStatsQuery = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.sites.getStats],
    queryFn: async () => {
      const response = await XHRAuthorizedClient.get<SiteStatsApiResponse>(
        ENDPOINTS.sites.stats
      );
      return response.data.data;
    },
  });
};
